var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticStyle:{"width":"320px"},attrs:{"rules":_vm.rules,"label":_vm.title,"clearable":_vm.clearable,"outlined":"","type":'number',"readonly":_vm.readOnly},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }